import { createFileRoute, Link } from "@tanstack/react-router"
import { ArrowLeft } from "lucide-react"

import { FeedbackEntryView } from "@/features/feedback/feedback-entry"

export const Route = createFileRoute("/feedback/$entryId")({
  component: FeedbackEntryScreen,
})

function FeedbackEntryScreen() {
  const { entryId } = Route.useParams()
  return (
    <>
      <Link
        to="/feedback"
        className="mb-4 inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground"
      >
        <ArrowLeft className="h-4 w-4" aria-hidden />
        All feedback
      </Link>
      <FeedbackEntryView id={Number(entryId)} />
    </>
  )
}
